<template>
  <div>
    <v-container>
      <v-layout row wrap align-center>
        <v-flex class="text-xs-center" xs12 sm12 lg9 style="margin:auto">
          <div class=" card-r no-shadow">
            <v-flex>
              <router-link to="`/`"><v-icon class="textColor left">keyboard_arrow_left</v-icon></router-link>
              <h1 class="f-20 mb-2 font-weight-bold">Teacher Schedule</h1>
              <!--<p class="text-xs-center f-15">Create Your New Teacher</p>-->

            </v-flex>
            <v-card class="card-r no-shadow">
              <v-form>
                <v-card-text class="pa-0">
                  <v-container grid-list-md>
                    <v-layout wrap>


                      <!--<v-flex xs12 class="checkbox">-->
                      <!--<v-checkbox-->
                      <!--v-model="policy"-->
                      <!--:rules="[v => !!v || 'You must agree to continue!']"-->
                      <!--label="Terms of Service and Privacy Policy "-->
                      <!--required-->
                      <!--&gt;</v-checkbox>-->
                      <!--</v-flex>-->
                      <span class="f-15 textColor font-weight-bold">Customize Teacher Schedule</span>
                      <!--<span class="f-20 w-100 text-xs-left textColor font-weight-bold">Create classs</span>-->
                      <!--<v-layout xs12>-->
                      <!--<v-flex xs10 offset-xs4>-->
                      <!--<h1 class="h1">Create Classes</h1>-->
                      <!--</v-flex>-->
                      <!--</v-layout>-->
                      <!--<span class="f-15 text-xs-left w-100 font-weight-medium">Week days</span>-->
                      <v-flex xs12 class="text-xs-left">

                        <v-tabs class="ma-2" slot="extension" v-model="tab" >
                          <v-tabs-slider color="unset"></v-tabs-slider>

                          <v-tab to="#tab-1">
                            <v-avatar color="primary">
                              <span class="f-12 font-weight-regular white--text">MON</span>
                            </v-avatar>
                          </v-tab>

                          <v-tab to="#tab-2">
                            <v-avatar color="primary">
                              <span class="f-12 font-weight-regular white--text">TUE</span>
                            </v-avatar>
                          </v-tab>

                          <v-tab to="#tab-3">
                            <v-avatar color="primary">
                              <span class="f-12 font-weight-regular white--text">WED</span>
                            </v-avatar>
                          </v-tab>
                          <v-tab to="#tab-4">
                            <v-avatar color="primary">
                              <span class="f-12 font-weight-regular white--text">THU</span>
                            </v-avatar>
                          </v-tab>

                          <v-tab to="#tab-5">
                            <v-avatar color="primary">
                              <span class="f-12 font-weight-regular white--text">FRI</span>
                            </v-avatar>
                          </v-tab>

                          <v-tab to="#tab-6">
                            <v-avatar color="primary">
                              <span class="f-12 font-weight-regular white--text">SAT</span>
                            </v-avatar>
                          </v-tab>
                          <v-tab to="#tab-7">
                            <v-avatar color="primary">
                              <span class="f-12 font-weight-regular white--text">SUN</span>
                            </v-avatar>
                          </v-tab>
                        </v-tabs>
                        <v-tabs-items v-model="tab">
                          <v-tab-item  v-for="i in 7" :value="'tab-' + i" :key="i">
                            <v-card flat class="">
                              <v-flex xs12 class="checkbox">

                                <v-checkbox
                                  label="same as previous schedule"
                                  required
                                ></v-checkbox>
                              </v-flex>
                              <span class="f-15 textColor font-weight-bold">Add Your Class Schedule</span>

                              <!--<span class="f-15 text-xs-left w-100 font-weight-bold">Lesson Start</span>-->
                              <!--<v-flex xs12 offset-xs0 class="pa-1 ">-->
                              <!--&lt;!&ndash;<VueCtkDateTimePicker v-model="yourValue" />&ndash;&gt;-->
                              <!--<v-select-->
                              <!--:items="timeslot"-->
                              <!--class="input-group&#45;&#45;focused"-->
                              <!--label="Lesson Start"-->
                              <!--&gt;</v-select>-->
                              <!--</v-flex>-->
                              <div xs12>
                                <v-flex xs12 offset-xs0 class="pa-1">
                                  <v-radio-group style="margin-bottom: -30px!important;" row class="ma-0">
                                    <v-radio color="primary" label="Work" value="radio-1"></v-radio>
                                    <v-radio color="primary" label="Break" value="radio-2"></v-radio>
                                    <v-radio color="primary" label="Express" value="radio-3"></v-radio>
                                  </v-radio-group>
                                </v-flex>
                              </div>
                              <v-layout xs12>
                                <v-flex xs6 offset-xs0 class="pa-1 ">
                                  <!--<span class="f-15 text-xs-left w-100 font-weight-bold">First Class</span>-->
                                  <!--<VueCtkDateTimePicker v-model="yourValue" />-->
                                  <v-select
                                    :items="timeslot"
                                    class="input-group--focused"
                                    label="First Class"
                                  ></v-select>
                                </v-flex>
                                <v-flex xs6 offset-xs0 class="pa-1 " >
                                  <!--<span class="f-15 text-xs-left w-100 font-weight-bold">Hours</span>-->
                                  <!--<VueCtkDateTimePicker v-model="yourValue" />-->
                                  <v-select
                                    :items="workMin"
                                    class="input-group--focused"
                                    label="Hours"
                                  ></v-select>
                                </v-flex>
                              </v-layout>
                              <!--<v-layout xs12>-->
                              <!--<v-flex xs6 offset-xs0 class="pa-1 ">-->
                              <!--&lt;!&ndash;<span class="f-15 text-xs-left w-100 font-weight-bold">Break Start</span>&ndash;&gt;-->
                              <!--&lt;!&ndash;<VueCtkDateTimePicker v-model="yourValue" />&ndash;&gt;-->
                              <!--<v-select-->
                              <!--:items="timeslot"-->
                              <!--class="input-group&#45;&#45;focused"-->
                              <!--label="Break Start"-->
                              <!--&gt;</v-select>-->
                              <!--</v-flex>-->
                              <!--<v-flex xs6 offset-xs0 class="pa-1">-->
                              <!--&lt;!&ndash;<span class="f-15 text-xs-left w-100 font-weight-bold">Hours</span>&ndash;&gt;-->
                              <!--&lt;!&ndash;<VueCtkDateTimePicker v-model="yourValue" />&ndash;&gt;-->
                              <!--<v-select-->
                              <!--:items="breakmin"-->
                              <!--class="input-group&#45;&#45;focused"-->
                              <!--label="Hours"-->
                              <!--&gt;</v-select>-->
                              <!--</v-flex>-->
                              <!--</v-layout>-->

                              <div v-for="n in counter" :key="n">
                                <div xs12>
                                  <v-flex xs12 offset-xs0 class="pa-1">
                                    <v-radio-group style="margin-bottom: -30px!important;" row class="ma-0">
                                      <v-radio color="primary" label="Work" value="radio-1"></v-radio>
                                      <v-radio color="primary" label="Break" value="radio-2"></v-radio>
                                      <v-radio color="primary" label="Express" value="radio-3"></v-radio>
                                    </v-radio-group>
                                  </v-flex>
                                </div>
                                <v-layout xs12>
                                  <v-flex xs5 offset-xs0 class="pa-1">
                                    <v-select
                                      :items="timeslot"
                                      class="input-group--focused"
                                      label="Starting Time"
                                    ></v-select>
                                  </v-flex>
                                  <v-flex xs5 lg6 offset-xs0 class="pa-1">
                                    <v-select
                                      :items="workMin"
                                      class="input-group--focused"
                                      label="Hours"
                                    ></v-select>
                                  </v-flex>
                                  <v-flex xs2 lg1 class="pa-1 text-xs-right">
                                    <v-btn fab outline small v-on:click="counter -= 1" color="primary">
                                      <v-icon dark>remove</v-icon>
                                    </v-btn>
                                  </v-flex>
                                </v-layout>
                              </div>

                              <span class="f-15 textColor font-weight-bold">Add More Schedule</span>

                              <v-layout >
                                <!--<v-flex xs12 offset-xs0 class="pa-1 text-xs-center">-->
                                <!--<v-btn icon outline color="blue"  v-on:click="counter += 1">dferwdva</v-btn>-->
                                <!--<v-btn icon v-show="show" v-on:click='ddd = !show' outline color="blue">a</v-btn>-->
                                <!--</v-flex>-->

                                <v-flex xs2 class="pa-1 ">
                                  <v-btn fab small outline color="primary" v-on:click="counter += 1">
                                    <v-icon dark>add</v-icon>
                                  </v-btn>
                                  <br>
                                  <!--<span class="f-12 ml-2 w-100 font-weight-bold">Add more</span>-->

                                </v-flex>
                              </v-layout>
                              <!--<v-tab xs12 icons-and-text>-->

                              <!--<v-layout>-->
                              <!--<v-flex xs4 class="pa-1 ">-->
                              <!--<v-avatar color="#0051a0">-->
                              <!--<v-icon dark>fas fa-plus-circle</v-icon>-->
                              <!--</v-avatar>-->
                              <!--<div class="f-15 text-xs-left w-100 font-weight-bold">WORK</div>-->
                              <!--</v-flex>-->
                              <!--<v-flex xs4 class="pa-1">-->
                              <!--<v-avatar color="#0051a0">-->
                              <!--<v-icon dark>fas fa-plus-circle</v-icon>-->
                              <!--</v-avatar>-->
                              <!--<div class="f-15 text-xs-left w-100 font-weight-bold">Break</div>-->
                              <!--</v-flex>-->
                              <!--<v-flex xs4 class="pa-1">-->
                              <!--<v-avatar color="#0051a0">-->
                              <!--<v-icon dark>fas fa-plus-circle</v-icon>-->
                              <!--</v-avatar>-->
                              <!--<div class="f-15 text-xs-left w-100 font-weight-bold">Express</div>-->
                              <!--</v-flex>-->
                              <!--</v-layout>-->
                              <!--</v-tab>-->
                              <!--<span class="f-15 text-xs-left w-100 font-weight-bold">Duration</span>-->
                              <span class="f-15 textColor font-weight-bold">Duration</span>

                              <v-layout xs12 class="mt-2">
                                <v-flex xs6 offset-xs0 class="pa-1">
                                  <span class="f-12 text-xs-left w-100 font-weight-bold pa-0">Start Date</span>
                                  <Datepiker/>
                                  <!--<VueCtkDateTimePicker v-model="yourValue" />-->
                                  <!--<vue-ctk-date-time-picker></vue-ctk-date-time-picker>-->
                                </v-flex>
                                <v-flex xs6 offset-xs0 class="pa-1">
                                  <span class="f-12 text-xs-left w-100 font-weight-bold">End Date</span>
                                  <Datepiker/>
                                  <!--<VueCtkDateTimePicker v-model="yourValue" />-->
                                </v-flex>
                              </v-layout>
                              <!--<v-btn class="create-class-btn ma-0 mt-2" color="primary">ADD</v-btn>-->
                            </v-card>
                          </v-tab-item>
                        </v-tabs-items>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <v-card-actions class>
                  <v-spacer></v-spacer>
                  <!--<v-btn to="/" class="no-shadow card-r">Close</v-btn>-->
                  <!--<v-btn-->
                  <!--class="card-r no-shadow"-->
                  <!--color="secondary"-->
                  <!--&gt;Create classs</v-btn>-->
                  <v-btn
                    class="card-r no-shadow text-white"
                    color="primary"
                    to="teachers"
                  >Save</v-btn>
                </v-card-actions>
              </v-form>
            </v-card>
          </div>
        </v-flex>
      </v-layout>
    </v-container>

  </div>

</template>

<script>
  /* eslint-disable */
  import Datepiker from "../Datepicker"
  import { mapState , dispatch } from "vuex"
  import VueDawa from "vue-dawa"
  export default {
    name: "AddNewStudent",
    data: () => ({
      tab :null,
      counter: 0,
      seen: true,
      show: true,
      // yourValue: '',
      date : null,
      birthday: false,
      type: ["Student", "Teacher"],
      gender: ["male", "female" ,"non binary"],
      timeslot: ["07:00 am", "08:00 am" , "09:00 am", "10:00 am" ,"11:00 am", "12:00 pm", "01:00 pm", "02:00 pm", "03:00 pm", "04:00 pm", "05:00 pm", "06:00 pm"],
      workMin: ["60 min", "120 min" , "180 min", "240 min" ,"300 min", "360 min", "420 min", "480 min" ],
      breakmin: ["15 min", "30 min" , "45 min", "60 min" ],
      passwordRule: [
        v => !!v || "Password is required",
        v => v.length >= 8 || "Password must be more than 8 characters"
      ]
    }),
    watch: {},
    created() {},
    methods: {
      selectItem(payload, objectName) {
        this.$set(this, objectName, this.translateData(payload));
      },
      translateData(address) {
        if (!address || !address.data) {
          return;
        }
        return {
          id: address.data.id,
          street: address.data.vejnavn,
          streetNumber: address.data.husnr,
          floor: address.data.etage,
          door: address.data.dør,
          zipCode: address.data.postnr,
          city: address.data.postnrnavn,
          oneLineAddress: address.tekst
        };

      },
    },
    components: {
      VueDawa,
      Datepiker
    }
  };
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/pages/teacher/TeacherSchedule.vue